module.exports = __webpack_public_path__ + "img/clock4-01.ae5e12c6.png";